import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { SFRTA_SwitchTestsAndInspectionsReportSections } from "./SFRTA_SwitchTestsAndInspectionsReportSchema";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { getCustomer, SUPPORTED_CUSTOMERS } from "../../../MainPage/VersionInfo";
import { cnFraMasterKey } from "../../CN/cnFraMasterKeys";
import AssetAreaCondition from "../../PATH/AssetAreaConditionReport";

const { monthly, quarterly, annually } = SFRTA_SwitchTestsAndInspectionsReportSections;

const quarterlyTestCodes = [
  "sfrtaSwitchcircuitControllerNormal",
  "CN_Quarterly_SwitchCircuitControllerNormal_FRA236_103",
  "sfrtaSwitchcircuitControllerReverse",
  "CN_Quarterly_SwitchCircuitControllerReverse_FRA236_103",
  "sfrtaSwitchshuntFouling",
  "CN_Quarterly_FoulingCircuits_FRA236_104",
  "path_valueLocksNonCutOffQuaterly",
  "path_restoreFeatureOnPowerSwitches",
];
const monthlyTestCodes = [
  "sfrtaSwitchLockRodNormal",
  "CN_Monthly_SwitchObstructionNormal_FRA236_382",
  "sfrtaSwitchLockRodReverse",
  "CN_Monthly_SwitchObstructionReverse_FRA236_382",
];
const annualTestCodes = ["path_valvesAndValveMagnets"];

const masterKey = [
  { key: "C", value: "Test completed, no exceptions found, and condition left in compliance." },
  { key: "A", value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance." },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },

  { key: "N", value: "Test Not Applicable." },
];

const ReportView = (props) => {
  let { data, isPreview } = props;
  const decodedData = Array.isArray(data.decodedData) ? data.decodedData : [];
  const monthlyData = decodedData.filter((t) => monthlyTestCodes.includes(t.testCode));
  const quarterlyData = decodedData.filter((t) => quarterlyTestCodes.includes(t.testCode));
  const annuallyData = decodedData.filter((t) => annualTestCodes.includes(t.testCode));
  const assetAreaConditionData = decodedData.filter((t) => t.testCode === "PATH_AssetAreaCondition");

  let showReport = assetAreaConditionData.length !== decodedData.length;
  if (!showReport && !isPreview) {
    return null;
  }

  return (
    (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection title="Inspection Report - Switch Tests & Inspections" {...props} fontSizeOverride={"35px"} />
        <span className="spacer"></span>
        <ReportFraInfoSectionContainer {...props} />
        <ReportFraConditionsMasterKey masterKey={getCustomer() === SUPPORTED_CUSTOMERS.CN ? cnFraMasterKey : masterKey} />
        <span className="spacer"></span>
        <AssetAreaCondition data={assetAreaConditionData} />
        {(monthlyData.length > 0 || isPreview) && (
          <table className="table-bordered" style={{ fontSize: "20px" }}>
            <ReportTableSectionRenderer section={monthly} rowsData={monthlyData} />
          </table>
        )}
        {(quarterlyData.length > 0 || isPreview) && (
          <table className="table-bordered" style={{ fontSize: "20px" }}>
            <ReportTableSectionRenderer section={quarterly} rowsData={quarterlyData} />
          </table>
        )}
        {(annuallyData.length > 0 || isPreview) && (
          <table className="table-bordered" style={{ fontSize: "20px" }}>
            <ReportTableSectionRenderer section={annually} rowsData={annuallyData} />
          </table>
        )}
      </div>
    )
  );
};

const SFRTA_SwitchTestsAndInspectionsReport = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ReportView data={{}} isPreview={isPreview} />;
  }

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    ...quarterlyTestCodes,
    ...monthlyTestCodes,
    ...annualTestCodes,
    "PATH_AssetAreaCondition",
  ]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups);

  return reportsWithDecodedFormData.map((report, i) => <ReportView key={i} {...props} data={report} />);
};

export default SFRTA_SwitchTestsAndInspectionsReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/SwitchTestsAndInspectionsReport/index.jsx